import { SeoHead, organizationLd, webSiteLd, webPageLd } from '../seo';

export default function Terms() {
  return (
    <>
      <SeoHead
        title="Terms of Use — Parksy.rent"
        description="Terms of using Parksy.rent: user content, matching consent, platform role, moderation, and liability."
        canonical="https://parksy.rent/terms"
        ogImage="https://parksy.rent/og/terms.png"
        schemas={[organizationLd(), webSiteLd(), webPageLd({ name: 'Terms of Use', description: 'Terms of using Parksy.rent.', url: 'https://parksy.rent/terms' })]}
      />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Use</h1>
        <div className="prose text-gray-600 space-y-4">
          <p>
            By using parksy.rent, you agree to these terms. If you do not agree, please do not
            use the platform.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">Your content</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>You are responsible for the accuracy of information you submit.</li>
            <li>Content must be truthful to the best of your knowledge.</li>
            <li>Prohibited: fake listings, false prices, defamatory content, spam.</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">Matching and contact sharing</h2>
          <p>
            By listing a spot or dropping a seeker pin, you consent to your email and phone being
            shared with matched users. Contacts are never shown on the map. If you do not want your
            contact shared further, delete your pin.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">Platform role</h2>
          <p>
            Parksy.rent is a discovery and matching platform only. We are not a parking operator,
            broker, or party to any transaction. We do not guarantee availability, safety, or
            accuracy of listings. Always verify details independently.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">Moderation</h2>
          <p>
            We reserve the right to remove content or ban IPs at our discretion. Pins receiving
            3 or more community reports are automatically hidden pending review.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">Limitation of liability</h2>
          <p>
            Parksy.rent is provided "as is" without warranties. We are not liable for any disputes,
            damages, or losses arising from use of the platform.
          </p>

          <p className="mt-6 text-sm text-gray-500">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </>
  );
}
